export const parseSelectedFiltersToOptions = <T>(options: T): Array<string> => {
  const temp = [] as Array<string>;
  for (const key in options) {
    if (Array.isArray(options[key])) {
      const arrFilters = options[key] as Array<string>;
      if (arrFilters.toString().length) {
        for (let i = 0; i < arrFilters.length; i += 1) {
          temp.push(arrFilters[i]);
        }
      }
    } else if (options[key] || Number.isFinite(options[key])) {
      temp.push(String(options[key]));
    }
  }
  return temp;
};
